<aff-header [showNavigation]="false"></aff-header>

<div
  id="unauthorised"
  class="pt-md pb-lg"
>
  <div class="text-align-center">
    <h1>Unauthorised access</h1>
  </div>

</div>
